import axios from 'axios'
const url = process.env.VUE_APP_HOST;

const getUserProfile = async function () {

    let _url = url + 'api/Foundation/user/profile'

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {
        access_token = process.env.VUE_APP_TOKEN;
        if (!access_token) {
            var query = window.location.hash
                .slice(2)
                .split('&')
                .filter(function (param) {
                    return !!param;
                })
                .reduce(function (memo, param) {
                    var keyValue = param.split('=');
                    memo[keyValue[0]] = keyValue[1];
                    return memo;
                }, {});

            if (query.access_token) {
                let auth = "{\"access_token\":\"" + query.access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
                localStorage.setItem('scientia-session-authorization', auth);
                access_token = query.access_token;
            }
        }
    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const getUser = async function (page = 1, itemsPerPage = 0, sortBy = "", sortDesc = "", searchTerm = "") {
    if (sortBy == 'Code')
        sortBy = 'HostKey';
    let _url = url + 'api/Foundation/user?page=' + page + '&itemsPerPage=' + itemsPerPage

    if (searchTerm) _url = _url + '&searchItem=' + searchTerm

    var asc = !Boolean(sortDesc[0]);

    if (sortBy != "")
        _url = _url + '&sortBy=' + sortBy + '&asc=' + asc

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const getUserByDept = async function (deptName, page = 1, itemsPerPage = 0, sortBy = "", sortDesc = "", isSystem = true) {
    if (sortBy == 'Code')
        sortBy = 'HostKey';

    let _url = url + 'api/Foundation/user/' + deptName + '?page=' + page + '&itemsPerPage=' + itemsPerPage

    var asc = !Boolean(sortDesc[0]);

    if (sortBy != "")
        _url = _url + '&sortBy=' + sortBy + '&asc=' + asc

    if (!isSystem)
        _url = _url + '&isSystem=false'

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const getGroup = async function (page = 1, itemsPerPage = 0, sortBy = "", sortDesc = "", searchTerm = "", tab = 0, isActive = true) {
    if (sortBy == 'Code')
        sortBy = 'HostKey';
    let _url = url + 'api/Foundation/department?page=' + page + '&itemsPerPage=' + itemsPerPage

    if (searchTerm) _url = _url + '&searchItem=' + searchTerm

    if (tab == 1) _url = _url + '&isSystem=false'

    var asc = !Boolean(sortDesc[0]);

    if (sortBy != "")
        _url = _url + '&sortBy=' + sortBy + '&asc=' + asc

    if (!isActive)
        _url = _url + '&isActive=false'

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const getGroupList = async function () {

    let _url = url + 'api/Foundation/department/list'

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}


const updateGroup = async function (payload) {

    let _url = url + 'api/Foundation/department/' + payload.identity

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    
    let result = await axios.put(_url, JSON.stringify(payload), headers).catch(error=>{
        return error.response;
    });

    return result.data;
}

const createGroup = async function (payload) {

    let _url = url + 'api/Foundation/department'

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url, JSON.stringify(payload), headers)

    return result.data;
}
const delGroup = async function (payload) {

    let _url = url + 'api/Foundation/department/'+payload.identity;

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.delete(_url, headers)

    return result.data;
}

const uploadFile = async function (id, payload) {
    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

    let _url = url + 'api/Foundation/Upload/GROUP?objectId='+ id
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           // 'Content-Type': 'multipart/form-data'
        }
    };
    let result = await axios.post(_url, payload.file, headers)

    if (result.status==200)
        return result.data;
    else
        return "ERROR"
}

const addUser = async function (groupId, id) {

    let _url = url + 'api/Foundation/UserGroup/'+groupId+'/add?id='+id

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url, '', headers)

    return result.data;
}

const removeUser = async function (groupId, id) {

    let _url = url + 'api/Foundation/UserGroup/'+groupId+'/remove?id='+id

    let access_token = "";

    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth) {

    }
    else {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url, '', headers)

    return result.data;
}

export const userService = { getUser, getGroup, getGroupList, updateGroup, getUserByDept, 
                                createGroup, delGroup, uploadFile, getUserProfile, addUser, removeUser }